import { Inspector, Flex } from '@sequencehq/core-components'
import { FC, ReactNode } from 'react'
import { netsuiteIntegrationConfig } from '../netsuite.integration.config'
import {
  LinkCustomerToServiceWidget,
  LinkProductWidget
} from '../../common/LinkEntities'
import { LinkOrCreateCustomerModal } from '../../common/LinkEntities/LinkCustomerToService/LinkOrCreateCustomerModal'
import { LinkOrCreateProductModal } from '../../common/LinkEntities/LinkProduct/LinkOrCreateProductModal'
import { AccountLinkWidget } from '../../common/LinkEntities/AccountLinkWidget/AccountLinkWidget'
import { LinkedInvoiceWidget } from '../../common/LinkEntities/LinkedInvoiceWidget/LinkedInvoiceWidget'
import { LinkedCreditNoteWidget } from '../../common/LinkEntities/LinkedCreditNoteWidget/LinkedCreditNoteWidget'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useIntegrationActive } from 'Integrations/utils/useIntegrationActive'

export const LinkNetsuiteCustomerWidget: FC<{
  customerId: string
  canUnlink?: boolean
}> = props => (
  <LinkCustomerToServiceWidget
    customerId={props.customerId}
    sequenceEntityLabel="customer"
    externalEntityLabel="customer"
    service="NetSuite"
    canUnlink={props.canUnlink}
    linkModal={linkProps => <LinkOrCreateCustomerModal {...linkProps} />}
  />
)

export const LinkNetsuiteProductWidget: FC<{
  productId: string
}> = props => (
  <LinkProductWidget
    productId={props.productId}
    sequenceEntityLabel="product"
    externalEntityLabel="service item"
    service="NetSuite"
    canUnlink={false}
    linkModal={LinkNetsuiteProductModal}
  />
)

export const LinkNetsuiteAccountWidget: FC<{
  productId: string
}> = props => (
  <AccountLinkWidget
    productId={props.productId}
    sequenceEntityLabel="Product"
    externalEntityLabel="Income account"
    service="NetSuite"
  />
)

const LinkNetsuiteProductModal: FC<{
  productId: string
  onClose: () => void
}> = ({ productId, onClose }) => (
  <LinkOrCreateProductModal
    productId={productId}
    service="NetSuite"
    externalEntityLabel="service item"
    onClose={onClose}
  />
)

export const LinkNetsuiteInvoiceWidget: FC<{ invoiceId: string }> = props => (
  <LinkedInvoiceWidget invoiceId={props.invoiceId} service="NetSuite" />
)

export const LinkNetsuiteCreditNoteWidget: FC<{
  creditNoteId: string
}> = props => (
  <LinkedCreditNoteWidget
    creditNoteId={props.creditNoteId}
    service="NetSuite"
  />
)

export const NetsuiteInspectorItem: FC<{
  children: ReactNode
}> = props => {
  const flags = useFeatureFlags()
  const integrationActive = useIntegrationActive('NetSuite')

  if (!flags.useNetsuite) return null
  if (!integrationActive) return null

  return (
    <Inspector.IconItem
      data-testid="netsuite.inspector.item"
      content={
        <Inspector.Content
          title="NetSuite"
          icon={<SmallIcon url={netsuiteIntegrationConfig.smallLogoUrl} />}
          data-testid="netsuite.inspector.content"
        >
          <Flex flexDirection="column" gap="16px">
            {props.children}
          </Flex>
        </Inspector.Content>
      }
      tooltip="NetSuite"
      icon={<SmallIcon url={netsuiteIntegrationConfig.smallLogoUrl} />}
    />
  )
}
